import {
    HttpResponse,
    AuditEscalationGroupModel,
    QueryModel,
    RequestParams,
    AuditEscalationGroupModelIEnumerableApiResultSuccess,
    AuditEscalationGroupModelApiResultSuccess,
    ApiResultFailed,
    Operation,
    AggregationModel,
    AggregationResponse,
    GrouppedQueryModel,
} from '@/libs/Api';
import ApiService from '@/libs/core/api-service';
import { CrudDataQuery, CrudService } from '@/libs/core/+state/models/crud-service';
import { CrudEnumerableResponse, CrudResponse } from '../core/+state/models/crud-response';
import { CrudPartialUpdatePatch } from '@/libs/core/+state/models/crud-partial-update-patch';

export class AuditEscalationGroupsDataService implements CrudService<AuditEscalationGroupModel, AuditEscalationGroupModel> {
    getAll(query: CrudDataQuery<AuditEscalationGroupModel>): Promise<CrudEnumerableResponse<AuditEscalationGroupModel>> {
        return ApiService.api.getAuditEscalationGroupBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    getBasicAll(query: CrudDataQuery<AuditEscalationGroupModel>): Promise<CrudEnumerableResponse<AuditEscalationGroupModel>> {
        throw new Error('NotImplemented');
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<AuditEscalationGroupModel>> {
        return ApiService.api.getAuditEscalationGroupById(id, params);
    }

    create(item: AuditEscalationGroupModel, params?: RequestParams): Promise<CrudResponse<AuditEscalationGroupModel>> {
        return ApiService.api.insertAuditEscalationGroup(item, params);
    }

    update(item: AuditEscalationGroupModel, params?: RequestParams): Promise<AuditEscalationGroupModel> {
        return ApiService.api.updateAuditEscalationGroup(item.id as Required<string>, item, params).then((req: any) => req.data.returnValue);
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<AuditEscalationGroupModel> {
        return ApiService.api.patchAuditEscalationGroup(id, patches, params).then((req: any) => req.data.returnValue);
    }

    delete(query: CrudDataQuery<AuditEscalationGroupModel>): Promise<CrudEnumerableResponse<AuditEscalationGroupModel>> {
        return ApiService.api.deleteAuditEscalationGroups(<any>query.data, query.params).then((req: any) => req.data.returnValue);
    }

    getAggregation(query: AggregationModel, params?: RequestParams): Promise<AggregationResponse> {
        return ApiService.api.aggregationAuditEscalationGroup(query, params).then((req: any) => req.data.returnValue);
    }

    download(query: CrudDataQuery<AuditEscalationGroupModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        throw new Error('NotImplemented');
    }

    clone(item: AuditEscalationGroupModel, params?: RequestParams): Promise<CrudResponse<AuditEscalationGroupModel>> {
        throw new Error('NotImplemented');
    }

    getGroupped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        return ApiService.api.getAuditEscalationGroupGroupped(query, params);
    }
}
